import React from 'react';
import { useParams } from 'react-router-dom';
import { CatalogForm } from '../../../components/CatalogForm/CatalogForm';
import { ListaPrecioTipoService } from '../../../services/ListaPrecioTipoService';
import { Validators } from '../../../components/CatalogForm/validators';

const formFields = [
  {
    name: 'lista_precio_tipo',
    label: 'Clave',
    type: 'text',
    col: 4,
    placeholder: 'Ej. MAY',
    validators: [
      Validators.required("La clave es obligatoria")
    ],
  },
  {
    name: 'lpt_nombre',
    label: 'Descripción',
    type: 'text',
    col: 8,
    placeholder: 'Ej. Mayoreo General',
    validators: [
      Validators.required("La descripción es obligatoria")
    ],
  },
];

export const ListaPrecioTipoForm = () => {
  const { id } = useParams();

  const handleLoadData = async (recordId) => {
    return await ListaPrecioTipoService.obtenerPorId(recordId);
  };

  const handleSubmit = async (values) => {
    return await ListaPrecioTipoService.guardar(values);
  };

  return (
    <CatalogForm
      title="Tipo de Lista de Precios"
      subtitle="Nivel o categoría de lista de precios aplicable"
      fields={formFields}
      id={id}
      loadData={handleLoadData}
      onSubmit={handleSubmit}
      backUrl="/Catalogo/ListasPreciosTipos"
    />
  );
};

export default ListaPrecioTipoForm;
